<template>
  <div v-if="hooks.length">
    <h4>{{ __('Integração via Rest Hook') }} <small><span class="badge badge-box">BETA</span></small></h4>

    <ul class="list-group question-sortable mt-4">
      <li
        class="list-group-item d-flex align-items-center"
        v-for="(hook, index) in hooks"
        :key="hook.id"
      >
        <strong class="mx-1">{{ hook.event }}</strong> <i class="fa fa-angle-right mr-1" /> {{ hook.target_url }}
        <span class="ml-auto">
          <a
            href="javascript:;"
            @click.prevent="destroy(hook, index)"
            v-if="! hook.busy"
          >Excluir</a>
          <i
            class="fa fa-spin fa-circle-o-notch"
            v-else
          />
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      hooks: [],
    };
  },

  created () {
    this.fetch();
  },

  methods: {
    fetch () {
      this.$http.get('/resthook')
        .then(({ data }) => data.map(({ id, event, target_url }) => ({
          id,
          event: this.getEventName(event),
          target_url,
          busy: false,
        })))
        .then((data) => this.hooks = data);
    },

    destroy (hook, index) {
      hook.busy = true;

      this.$http.delete(`/resthook/${hook.id}`)
        .then(() => this.hooks.splice(index, 1));
    },

    getEventName (event) {
      switch (event) {
        case 'lead.created':
          return this.__('Novo Lead');
        case 'lead.converted':
          return this.__('Nova Conversão');
        case 'lead.updated':
          return this.__('Lead Atualizado');
        case 'lead.deal.added':
          return this.__('Negócio criado');
        case 'lead.deal.lost':
          return this.__('Negócio perdido');
        case 'lead.deal.closed':
          return this.__('Negócio ganho');
      }

      return event;
    },
  },
};
</script>
